import AppPageTextInput from "./AppPageTextInput";

import "./AppPageTextInput.scss";

export { AppPageTextInput as AppPageTextInput };